export var HistoryEventType;
(function (HistoryEventType) {
    HistoryEventType["POINTS_ADDED"] = "POINTS_ADDED";
    HistoryEventType["LIVE_TAKEN"] = "LIVE_TAKEN";
    HistoryEventType["SEGMENT_HIT"] = "SEGMENT_HIT";
    HistoryEventType["NEXT_PLAYER"] = "NEXT_PLAYER";
    HistoryEventType["HALF_IT"] = "HALF_IT";
    HistoryEventType["SHUFFLE_PLAYERS"] = "SHUFFLE_PLAYERS";
    HistoryEventType["SPINNING_WHEEL_PLUS_ONE_DART"] = "SPINNING_WHEEL_PLUS_ONE_DART";
    HistoryEventType["SPINNING_WHEEL_MINUS_ONE_DART"] = "SPINNING_WHEEL_MINUS_ONE_DART";
    HistoryEventType["SPINNING_WHEEL_PLUS_TWO_DARTS"] = "SPINNING_WHEEL_PLUS_TWO_DARTS";
    HistoryEventType["SPINNING_WHEEL_PLUS_25_POINTS"] = "SPINNING_WHEEL_PLUS_25_POINTS";
    HistoryEventType["SPINNING_WHEEL_MINUS_TWO_DARTS"] = "SPINNING_WHEEL_MINUS_TWO_DARTS";
    HistoryEventType["SPINNING_WHEEL_PLUS_THREE_DARTS"] = "SPINNING_WHEEL_PLUS_THREE_DARTS";
    HistoryEventType["SPINNING_WHEEL_MINUS_25_POINTS"] = "SPINNING_WHEEL_MINUS_25_POINTS";
    HistoryEventType["SPINNING_WHEEL_USE_OTHER_ARM"] = "SPINNING_WHEEL_USE_OTHER_ARM";
    HistoryEventType["SPINNING_WHEEL_PLUS_ONE_DART_OTHER_ARM"] = "SPINNING_WHEEL_PLUS_ONE_DART_OTHER_ARM";
    HistoryEventType["SPINNING_WHEEL_PLUS_TWO_DARTS_OTHER_ARM"] = "SPINNING_WHEEL_PLUS_TWO_DARTS_OTHER_ARM";
    HistoryEventType["SPINNING_WHEEL_PLUS_THREE_DARTS_OTHER_ARM"] = "SPINNING_WHEEL_PLUS_THREE_DARTS_OTHER_ARM";
    HistoryEventType["SPINNING_WHEEL_ONE_HIT"] = "SPINNING_WHEEL_ONE_HIT";
    HistoryEventType["SPINNING_WHEEL_ONE_METER_BACK"] = "SPINNING_WHEEL_ONE_METER_BACK";
    HistoryEventType["SPINNING_WHEEL_THROW_THREE_DARTS_AT_ONCE"] = "SPINNING_WHEEL_THROW_THREE_DARTS_AT_ONCE";
    HistoryEventType["SPINNING_WHEEL_TWO_HITS_NEEDED"] = "SPINNING_WHEEL_TWO_HITS_NEEDED";
    HistoryEventType["SPINNING_WHEEL_SUM_COUNTS"] = "SPINNING_WHEEL_SUM_COUNTS";
    HistoryEventType["SPINNING_WHEEL_SIT_DOWN"] = "SPINNING_WHEEL_SIT_DOWN";
    HistoryEventType["SPINNING_WHEEL_REVERSE_DARTS"] = "SPINNING_WHEEL_REVERSE_DARTS";
    HistoryEventType["SPINNING_WHEEL_CLOCKWISE_SECTOR_COUNTS"] = "SPINNING_WHEEL_CLOCKWISE_SECTOR_COUNTS";
    HistoryEventType["SPINNING_WHEEL_ONE_DART_EACH_ARM"] = "SPINNING_WHEEL_ONE_DART_EACH_ARM";
    HistoryEventType["SPINNING_WHEEL_SCORE_TIMES_TWO"] = "SPINNING_WHEEL_SCORE_TIMES_TWO";
    HistoryEventType["SPINNING_WHEEL_ONE_METER_RIGHT"] = "SPINNING_WHEEL_ONE_METER_RIGHT";
})(HistoryEventType || (HistoryEventType = {}));
